{
  "LOGIN": {
    "TITLE": "Kirjaudu sisään yhteyskeskukseen",
    "EMAIL": {
      "LABEL": "Sähköposti",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Ole hyvä ja syötä validi sähköposti"
    },
    "PASSWORD": {
      "LABEL": "Salasana",
      "PLACEHOLDER": "Salasana"
    },
    "API": {
      "SUCCESS_MESSAGE": "Kirjautuminen Onnistui",
      "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen",
      "UNAUTH": "Käyttäjätunnus / salasana virheellinen. Yritä uudelleen",
      "ACCOUNT_DEACTIVATED": "Tilisi on poistettu käytöstä. Ota yhteyttä pääkäyttäjääsi.",
      "PASSWORD_LOGIN_DISABLED": "Salasanalla kirjautuminen on poistettu käytöstä tililläsi. Kirjaudu sisään OAuthin avulla (esim. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Salasana unohtunut?",
    "CREATE_NEW_ACCOUNT": "Luo uusi tili",
    "SUBMIT": "Kirjaudu"
  }
}
